// Snackbar templates for the notification container and message items.
import { escapeHtml } from '../utils/html'

type SnackbarType = 'default' | 'error' | null

/** Renders the global snackbar host element. */
export function snackbarContainerTemplate(id: string): string {
	return `<div id="${id}"></div>`
}

/** Renders a single snackbar notification. */
export function snackbarTemplate(message: string, type: SnackbarType): string {
	const typeClassName = type ? ` ${type}` : ''

	return `
        <div class="snackbar${typeClassName}" role="status">
            <span>${escapeHtml(message)}</span>
        </div>
    `
}
